import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import RepVisitsTravelPlanComponent from './repvisits-travel-plan';
import RemoveTravelPlanMutation from './remove-travel-plan-mutation';
import formatDate from '../../utils/format-date';

const query = gql`
      query RepVisitsTravelPlanSearch($fromDate: OrdinalDate) {
        viewer {
          id
          enabledFeatures
          repVisitsTravelPlan {
            id
            hasCollegeFairs
            hasRepVisits
            name
            address {
               field_hs_elna_address_line1
               field_hs_elna_city
               field_hs_elna_state_latest
               field_hs_el_county_name
               field_hs_eln_zip
            }
            enrollmentByGrade {
              field_hs_el_grade_12_students
            }
            general {
              field_hs_elna_school_type
            }
            naviance {
              field_hs_na_percent_college
            }
            repVisitsAccount {
              id
              primaryContact {
                id
                name
              }
            }
            collegeFairs(fromDate: $fromDate, first: 1) {
              edges {
                node {
                  id
                  name
                  date
                }
              }
            }
            viewerRepVisitsEvents {
              id
              name
              date
              timezone
              dayId
              startISOTime
              endISOTime
              collegeFairId
              appointmentId
              notes
              startTime
              endTime
              userBookingStatus
              chosenVisitLocationType
              highSchool {
                id
                address {
                  field_hs_eln_zip
                  field_hs_elna_address_line1
                  field_hs_elna_city
                  field_hs_elna_state_latest
                }
                repVisitsAccount {
                  id
                  primaryContact {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    `;

const graphqlData = graphql(query, {
  options: () => ({
    variables: {
      fromDate: formatDate(new Date(Date.now() - (1000 * 60 * 60 * 24))),
    },
    fetchPolicy: 'cache-and-network',
  }),
});

const RemoveTravelPlan = graphql(RemoveTravelPlanMutation, { name: 'removeTravelPlan' });

export default SimpleGraphQLComponent(graphqlData, RemoveTravelPlan)(RepVisitsTravelPlanComponent);
